var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpSkills(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Skill upgradation and Career assistance Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000004727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 19.071H13V11.071H15V19.071ZM7 19.071H5V11.071H7V19.071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 19.071H17V13.0002H19V19.071Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.9998 19.071H8.99984V9.071H5.96484L9.96484 5L13.9648 9.071H10.9998V19.071Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15 9.375C15 9.04348 15.1317 8.72554 15.3661 8.49112C15.6005 8.2567 15.9185 8.125 16.25 8.125H18.75C19.0815 8.125 19.3995 8.2567 19.6339 8.49112C19.8683 8.72554 20 9.04348 20 9.375C20 9.54076 19.9342 9.69973 19.8169 9.81694C19.6997 9.93415 19.5408 10 19.375 10H15.625C15.4592 10 15.3003 9.93415 15.1831 9.81694C15.0658 9.69973 15 9.54076 15 9.375Z",
    stroke: "white",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.5 6.875C18.0178 6.875 18.4375 6.45527 18.4375 5.9375C18.4375 5.41973 18.0178 5 17.5 5C16.9822 5 16.5625 5.41973 16.5625 5.9375C16.5625 6.45527 16.9822 6.875 17.5 6.875Z",
    stroke: "white"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpSkills);
export default __webpack_public_path__ + "static/media/up-skills.119f3af67bfc0c59cc18edce30411e6a.svg";
export { ForwardRef as ReactComponent };